


































import { Vue, Component, Prop } from 'vue-property-decorator';
import { NewsDetail } from '@/modules/admin/news';
import { ElForm } from 'element-ui/types/form';

@Component
export default class NewsEdit extends Vue {
  @Prop() private newsId: string;

  private customToolbar = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered'}, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1'}, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link']
  ];
  private isEdit = false;
  private previewVisible = false;

  private formRule = {
    publicationDate: [
      { required: true, message: '掲載日を入力してください' },
    ],
    title: [
      { required: true, message: 'タイトルを入力してください' },
    ],
    note: [
      { required: true, message: '内容を入力してください' },
      { validator: this.validateBody, trigger: 'blur' },
    ],
  };

  private validateBody(rule: any, value: string, callback: any) {
    if (value === '') {
      callback(new Error('内容を入力してください'));
    } else {
      callback();
    }
  }

  get news(): NewsDetail {
    return this.$store.state.adminNews.selectedNews;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    const page = String(this.$route.name);
    const isEdit = (page.toUpperCase() === 'adminNewsEdit'.toUpperCase());

    this.isEdit = isEdit;

    if (!!this.newsId) {
      try {
        await this.$store.dispatch('adminNews/selectNews', this.newsId);
      } catch (error) {
        //
      }

      if (!this.news) {
        this.$router.push({
          name: 'AdminNewsList',
        });
        return;
      }
    } else {
      this.$store.commit('adminNews/initSelectedNews');
    }
    this.$nextTick(() => {
      (this.$refs.form as ElForm).clearValidate();
    });
  }
  private submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        this.onRegist();
      } else {
        return false;
      }
    });
  }

  private onRegist() {
    if (this.isEdit) {
      this.editNews();
    } else {
      this.createNews();
    }
  }

  private async createNews() {
    let confirmText: string;
    if (!this.news.publicationDate || this.news.publicationDate <= new Date()) {
      confirmText = '即座にお知らせを掲載します。登録してよろしいですか？';
    } else {
      const publicationDateText = (this as any).$moment(this.news.publicationDate).format('YYYY年MM月DD日');
      confirmText = `${publicationDateText} にお知らせを掲載します。登録してよろしいですか？`;
    }
    try {
      await this.$confirm(confirmText, 'お知らせ登録', {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminNews/createNews', this.news);

      await this.$store.dispatch(
        'adminNews/searchNews',
        this.$store.state.adminNews.searchCondition
      );

      this.$router.push({ name: 'AdminNewsList' });

      this.$notify({
        title: 'お知らせ登録完了',
        message: 'お知らせを登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'お知らせ登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async editNews() {
    let confirmText: string;
    if (!this.news.publicationDate || this.news.publicationDate <= new Date()) {
      confirmText = '即座にお知らせを掲載します。登録してよろしいですか？';
    } else {
      const publicationDateText = (this as any).$moment(this.news.publicationDate).format('YYYY年MM月DD日');
      confirmText = `${publicationDateText} にお知らせを掲載します。登録してよろしいですか？`;
    }
    try {
      await this.$confirm(confirmText, 'お知らせ変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminNews/editNews', this.news);

      this.$router.push({ name: 'AdminNewsList' });

      this.$notify({
        title: 'お知らせ変更完了',
        message: 'お知らせを変更しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'お知らせ変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private onCancel() {
    this.$router.push({ name: 'AdminNewsList' });
  }
}
